module.exports = {
  RETRIEVE_INBOUND_POSTAL_OPERATOR_MAILBOX_REQUEST: 'RETRIEVE_INBOUND_POSTAL_OPERATOR_MAILBOX_REQUEST',
  RETRIEVE_INBOUND_POSTAL_OPERATOR_MAILBOX_SUCCESS: 'RETRIEVE_INBOUND_POSTAL_OPERATOR_MAILBOX_SUCCESS',
  RETRIEVE_INBOUND_POSTAL_OPERATOR_MAILBOX_FAILURE: 'RETRIEVE_INBOUND_POSTAL_OPERATOR_MAILBOX_FAILURE',
  ARRIVAL_MAILBOX_CHECKED: 'ARRIVAL_MAILBOX_CHECKED',
  ARRIVAL_POSTAL_OPERATOR_EXPANDED: 'ARRIVAL_POSTAL_OPERATOR_EXPANDED',
  SELECT_ALL_ARRIVAL_MAILBOXES: 'SELECT_ALL_ARRIVAL_MAILBOXES',
  DESELECT_ALL_ARRIVAL_MAILBOXES: 'DESELECT_ALL_ARRIVAL_MAILBOXES',
};
